<button (click)="goBack()"
        class="p2">
    <i class="icon-chevron-left p-l-2"
       [style.font-size.rem]="0.8"></i>
    <span class="p-l-3"
          translate>
        Continue Shopping</span>
</button>